import { Link } from '@inertiajs/react'
import { Wordmark } from '../components/core/Wordmark.jsx'

// The logo at the top of the nine standalone pages — sign in, sign up, both
// reset pages, both verification pages, both invitation pages and unsubscribe.
// **It links home**, the founder's call 2026-10-23: these pages carry no nav,
// so before this the only way from sign-in to the home page was typing the
// address. They carry the site's footer below them since 2026-10-30, and still
// no header — each is a single task.
//
// One component rather than nine copies, because the pages are one flow — the
// page you sign up on and the page a reset link returns you to — and the old
// note on each said "change all six together" while there were nine.
//
// 38, and 16px of extra room under it. These pages stand alone, so the mark is
// read against the 28px heading rather than against nav links, and at 19 it was
// two-thirds of it. Nav chrome stays 23. The margin is on the mark rather than
// on the column's `gap-8`, which sits between every child and would re-space
// the whole page. `self-start` keeps the link to the mark's width: the column
// stretches its children, and a full-width link would make the empty space
// beside the logo clickable.
export function HomeMark() {
  return (
    <Link href="/" aria-label="Spruce, home" className="mb-4 self-start">
      <Wordmark size={38} />
    </Link>
  )
}
